import React, { Component } from 'react';
import {
    avgMessageVolumeProtectionRateSelector,
    messageVolumeCoverageIsLoadedSelector,
} from '../../selectors/message-volume-coverage-selectors';
import {
    formattedEndDateSelector,
    formattedStartDateSelector
} from '../../selectors/reports-selectors';

import ProgressBulletGroup from '../../components/progress-bullet-group';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getDifferenceInRange } from '../../../utils/report-utils';

export class MessageVolumeCoverageProgressBulletsContainer extends Component{
    buildBulletMap = () => {
        const { startDate, endDate, rate } = this.props;
        const numberOfDays = getDifferenceInRange( startDate, endDate );

        return [
            { text: `Our average protection rate from blocking policies over ${numberOfDays} days (between ${startDate} and ${endDate}) was ${rate}%.` },
            { text: ' Implementing blocking policies results in 100% of authorized email being protected.' }
        ];
    }

    render(){
        const { isLoaded } = this.props;

        return (
            isLoaded &&
            <ProgressBulletGroup bullets={this.buildBulletMap()} />
        );
    }
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        endDate: formattedEndDateSelector( state ),
        isLoaded: messageVolumeCoverageIsLoadedSelector( state ),
        rate: avgMessageVolumeProtectionRateSelector( state ),
        startDate: formattedStartDateSelector( state ),
    };
};

MessageVolumeCoverageProgressBulletsContainer.propTypes = {
    endDate: PropTypes.string.isRequired,
    isLoaded: PropTypes.bool.isRequired,
    rate: PropTypes.string.isRequired,
    startDate: PropTypes.string.isRequired,
};

export default connect( mapStateToProps )( MessageVolumeCoverageProgressBulletsContainer );
